"use strict";

var _slicedToArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var _default = function _default(_ref) {
  var index = _ref.index,
    data = _ref.data,
    classes = _ref.classes,
    maxItems = _ref.maxItems,
    onSectionClick = _ref.onSectionClick,
    onItemClick = _ref.onItemClick;
  var items = data.items,
    section = data.section;
  var _ref2 = (0, _react.useState)(true),
    _ref3 = _slicedToArray(_ref2, 2),
    expand = _ref3[0],
    setExpand = _ref3[1];
  var noOfItems = expand ? items.length : maxItems;
  var clsName = function clsName() {
    var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var attr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return "facetSection".concat(text.replace(/\s+/g, '')).concat(attr);
  };
  return /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("span", null, ' ', index !== 0 ? /*#__PURE__*/_react.default.createElement("span", {
    className: classes.operators
  }, " AND ") : '', /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _clsx.default)(classes.filterName, classes["".concat(clsName(section, 'Background'))]),
    onClick: function onClick() {
      return onSectionClick(data);
    }
  }, data.label), ' '), /*#__PURE__*/_react.default.createElement("span", null, ' ', /*#__PURE__*/_react.default.createElement("span", {
    className: classes.operators
  }, items.length === 1 ? 'IS ' : 'IN '), items.length > 1 && /*#__PURE__*/_react.default.createElement("span", {
    className: classes.bracketsOpen
  }, "("), items.slice(0, noOfItems).map(function (d, idx) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
      className: (0, _clsx.default)(classes.filterCheckboxes, classes[clsName(section)]),
      key: idx,
      onClick: function onClick() {
        return onItemClick(data, d);
      }
    }, d), idx === maxItems - 1 ? null : ' ');
  }), items.length > maxItems && !expand && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
    className: classes.expandBtn,
    onClick: function onClick() {
      return setExpand(!expand);
    }
  }, "...")), expand && items.length > maxItems && /*#__PURE__*/_react.default.createElement("span", {
    className: classes.collapseBtn,
    onClick: function onClick() {
      return setExpand(!expand);
    }
  }, ' LESS'), items.length > 1 && /*#__PURE__*/_react.default.createElement("span", {
    className: classes.bracketsClose
  }, ")")));
};
exports.default = _default;